<template>
  <!-- 根视图 -->
  <div class="globe-main">
    <!-- 北师大增加返回按钮 -->
    <img v-if="$store.state.data.type == 8" class="back-img" @click="backTap" :src="`${$store.state.data.baseUrl}/back.png`" />
    <!-- 背景1 北师大单独设置首页背景图 -->
    <!-- 30 重庆医科大学单独设置背景图 -->
    <div v-if="$store.state.data.type != 8"
         class="bg-img"
         :class="{ 'bg-img-30': $store.state.data.type == 30 }"
         :style="{ 'background': `url(${$store.state.data.baseUrl}/bg2.png) no-repeat 0 0`,
                   'background-size': $store.state.data.type == 3 ? '100% 100%' : 'cover' }"></div>
    <img v-else v-show="$store.state.data.type != 8 || globeType === 0" class="bg-img" :style="$store.state.data.type == 8 ? 'height: 50%; z-index: 1; bottom: auto;' : ''" :src="`${$store.state.data.baseUrl}/bg2.png?new`" alt="">
    <!-- 河南职业技术学院、中国劳动关系学院21 不展示 -->
    <img class="bg-img"
          v-if="$store.state.data.type == 19 || $store.state.data.type == 21"
          v-show="globeType === 0"
          :style="{ 'background': `url(${$store.state.data.baseUrl}/bg1.png) no-repeat 0 0`,
                   'background-size': $store.state.data.type == 3 ? '100% 100%' : 'cover' }" alt="">
    <!-- 背景2 北京外国语学校 || 北京建筑大学 || 北京航空航天大学 || 北京科技大学 || 西安外事学院 || 广州医科 || 陕西中医药 || 北师大实验中学/二龙路中学 单独设置 -->
    <!-- 30 重庆医科大学单独设置背景图 -->
    <img class="bg-img"
          :class="{ 'bg1-img-30': $store.state.data.type == 30 }"
          v-else-if="$store.state.id != 26"
          v-show="globeType === 0"
          :style="$store.state.data.type == 2 || $store.state.data.type == 4 ||
                  $store.state.data.type == 5 || $store.state.data.type == 6 ||
                  $store.state.data.type == 7 || $store.state.data.type == 9 ||
                  $store.state.data.type == 10 ? 'height: 50%; z-index: 1;' :
                  $store.state.data.type == 13 ? 'z-index: 1;' : 'object-fit: fill;'"
          :src="`${$store.state.data.baseUrl}/bg1.png?new`" alt="">
    <!-- 背景4 协和单独设置 -->
    <img class="bg4-img" v-show="globeType === 0 && $store.state.data.type == 3" :src="`${$store.state.data.baseUrl}/bg4.png`" alt="">
    <!-- 背景4 中国农业大学单独设置 -->
    <img class="bg5-img" v-show="globeType === 0 && $store.state.data.id == 26" :src="`${$store.state.data.baseUrl}/bg5.png`" alt="">
    <!-- 第几位点亮 北师大单独设置第几位点亮标题 -->
    <div v-if="$store.state.id == 8" class="click-num beishida-click-num" v-show="globeType >= 2 && total">您是我们找到的第 <p>{{total}}</p> 位北师大人</div>
    <!-- 第几位点亮 中国农业大学单独设置第几位点亮标题 -->
    <div v-else-if="$store.state.id == 26" class="click-num click-num-nd" v-show="globeType >= 2 && total">
      <img :src="`${$store.state.data.baseUrl}/total-bg.png`" alt="">
      <span>CAU，亲爱的母校</span>
      <div>我在<p>{{area}}</p></div>
      <span>为您的双甲子华诞</span>
      <div>送上<p>第{{total}}份</p>诚挚祝福</div>
    </div>
    <div v-else-if="$store.state.data.type == 30" class="click-num click-num-30" v-show="globeType >= 2 && total">
      <div>您是第<p>{{total}}</p>位点亮的校友</div>
    </div>
    <!-- 第几位点亮 -->
    <div v-else class="click-num" v-show="globeType >= 2 && total">您是第 <p>{{total}}</p> 位点亮的校友</div>
    <!-- 挂载 echarts 北师大单独设置地球位置 -->
    <div
      :hidden="globeType === 0 && ($store.state.id == 8 || $store.state.data.type == 19 || $store.state.data.type == 30)"
      :style="$store.state.id == 8 ? 'top: 1.8rem;' : (globeType === 0 && $store.state.data.type == 21 ? 'opacity: 0;': '')"
      id="echarts"
      :class="$store.state.id == 26 ? 'echarts-26' : ''"
    ></div>
    <!-- 21 中国劳动关系学院 单独设置Logo -->
    <img v-if="$store.state.data.type == 21" v-show="globeType === 0" class="logo-tag" :src="`${$store.state.data.baseUrl}/bg_tag.png`" alt="">
    <!-- 19 河南职业技术学院 单独设置大小 -->
    <img v-if="$store.state.data.type == 19" v-show="globeType === 0" class="title-19" :src="`${$store.state.data.baseUrl}/school_title.png`" alt="">
    <!-- 学校名称 -->
    <img v-else v-show="globeType === 0 && !($store.state.data.type == 26 || $store.state.data.type == 30)" class="title" :style="$store.state.id == 8 ? 'top: 4.5rem; right: 1rem;' : ''" :src="`${$store.state.data.baseUrl}/school_title.png`" alt="">
    <!-- 19 河南职业技术学院 单独设置大小 -->
    <div :class="$store.state.data.type == 19 ? 'click-button-19' : 'click-button-21'"
          v-if="$store.state.data.type == 19 || $store.state.data.type == 21"
          :style="{'background-image': 'url(' +
          (globeType === 0 ? `${$store.state.data.baseUrl}/globe_button1.png` :
          globeType === 1 ? `${$store.state.data.baseUrl}/globe_button2.png` :
          globeType === 2 ? `${$store.state.data.baseUrl}/${$store.state.id == 26 ? '' : 'globe_button3'}.png` :
          $store.state.data.type == 15 ? `${$store.state.data.baseUrl}/globe_button5.png` : `${$store.state.data.baseUrl}/globe_button4.png`) + ')',
          'bottom': $store.state.id == 8 && globeType !== 0 ? '4.10rem' : '1.333333rem',
          'width': $store.state.id == 8 ? globeType === 0 && '9.1rem' || globeType === 1 && '8.5rem' : ''}"
          @click="clickLight"></div>
    <!-- 26 中国农业大学 单独设置大小 -->
    <div class="click-button-26"
          v-else-if="$store.state.data.id == 26"
          :style="{'background-image': 'url(' +
          (globeType === 0 ? `` :
          globeType === 1 ? `${$store.state.data.baseUrl}/globe_button2.png` :
          globeType === 2 ? `` : `${$store.state.data.baseUrl}/globe_button4.png`) + ')',
          'top': globeType === 0 ? '0' : '',
          'left': globeType === 0 ? '0' : '',
          'width': globeType === 0 ? '100vw' : '',
          'height': globeType === 0 ? '100vh' : '',}"
          @click="clickLight"></div>
    <!-- 底部按钮 北师大单独设置按钮位置 重庆大学不展示查看详情展示返回 -->
    <div class="click-button"
          :class="{ 'click-button-30': $store.state.data.type == 30, 'click-button-29': $store.state.id == 29 && globeType === 2 }"
          v-else
          :style="{'background-image': 'url(' +
          (globeType === 0 ? `${$store.state.data.baseUrl}/globe_button1.png` :
          globeType === 1 ? `${$store.state.data.baseUrl}/globe_button2.png` :
          globeType === 2 ? `${$store.state.data.baseUrl}/${$store.state.id == 26 ? '' : 'globe_button3'}.png` :
          $store.state.data.type == 15 ? `${$store.state.data.baseUrl}/globe_button5.png` :
          $store.state.data.type == 30 ? `${$store.state.data.baseUrl}/globe_button3.png` : `${$store.state.data.baseUrl}/globe_button4.png`) + ')',
          'bottom': $store.state.id == 8 && globeType !== 0 ? '4.10rem' : '1.333333rem',
          'width': $store.state.id == 8 ? globeType === 0 && '9.1rem' || globeType === 1 && '8.5rem' : ''}"
          @click="clickLight"></div>

    <!-- 广东培正29 增加跳转校友板块功能 -->
    <div v-if="$store.state.id == 29 && globeType === 2" class="click-button-student" @click="peizhengStudentTap">
      <img :src="`${$store.state.data.baseUrl}/globe_button5.png`" alt="">
    </div>
    <!-- 26 农大二维码 -->
    <img v-if="$store.state.id == 26" class="code" :src="`${$store.state.data.baseUrl}/code.png`" alt="">

    <!-- 北师大单独设置增加三个操作 -->
    <div v-if="$store.state.id == 8 && globeType !== 0" class="bottom-handle">
      <div class="handle" v-for="item in 3" :key="item" @click="handleTap(item)">
        <template>
          <img :src="`${$store.state.data.baseUrl}/handle${item}.png`" alt="">
          <div>{{ ['祝福母校', '邀你回家', '为母校助力'][item - 1] }}</div>
        </template>
        <!-- <wx-open-launch-weapp v-if="item == 2" @error="wxOpenError" username="gh_45eb998b5f2b" path="pkgMain/pages/index?page=2" :style="{ position: 'absolute', top: 0, 'left': 0, 'z-index': 10, width: '100%', height: '100%', opacity: 0}">
          <script type="text/wxtag-template">
            <style>.btn { width: 100%; height: 100%; margin: 19px 0 50px 0; font-size: 26px; }</style>
            <button class="btn">邀你回家</button>
          </script>
        </wx-open-launch-weapp>
        <wx-open-launch-weapp v-if="item == 3" @error="wxOpenError" username="gh_45eb998b5f2b" path="pkgMain/pages/index?activeId=97&orderNum=12&page=2" :style="{ position: 'absolute', top: 0, 'left': 0, 'z-index': 10, width: '100%', height: '100%', opacity: 0}">
           <script type="text/wxtag-template">
            <style>.btn { width: 100%; height: 100%; margin: 19px 0 50px 0; font-size: 26px; }</style>
            <button class="btn">为母校助力</button>
          </script>
        </wx-open-launch-weapp> -->
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts-gl';
import {
  geolocation, globe, weapp, school,
} from '@/services/data';

const wx = require('weixin-js-sdk');

export default {
  name: 'globeMap',
  data() {
    return {
      // 重庆大学默认展示已进入界面
      globeType: this.$store.state.data.type == 15 ? 1 : 0, // 地球状态 0: 未进入 1: 已进入 2: 已定位 3: 已经获取全部 4: 已经进入详情
      position: {}, // 获取的地理位置
      myChart: null, // echarts 实例
      optionGlobe: {}, // 地球数据
      total: 0, // 第几位点亮的
      area: '', // 在哪点亮的
    };
  },
  created() {

  },
  mounted() {
    // 获取echarts挂载dom实例
    const chartDom = document.getElementById('echarts');
    // 创建echarts实例 北师大单独设置地球大小
    this.myChart = echarts.init(chartDom, null, { width: this.$store.state.data.type == 8 ? 280 : 375, height: this.$store.state.data.type == 8 ? 280 : 375 });
    // 设置地球option
    this.optionGlobe = {
      // 地球组件
      globe: {
        // top: '10%',
        // let: '10%',
        // width: '80%',
        // height: '80%',
        show: true, // 是否显示地球组件
        globeRadius: this.$store.state.data.type == 8 ? 75 : 100, // 地球的三维空间半径 北师大单独设置地球大小
        globeOuterRadius: this.$store.state.data.type == 8 ? 77 : 102, // 地球的外半径，内外半径间展示三维柱状图或者散点图之类的 北师大单独设置光柱大小
        // environment: `${ROOT_PATH}/data-gl/asset/starfield.jpg`, // 环境贴图，支持图片路径、颜色、渐变色
        // baseTexture: `${process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/api'}/images/globe.jpg`,
        baseTexture: (this.$store.state.data.type == 8 || this.$store.state.id == 26 || this.$store.state.data.type == 30) ? `${this.$store.state.data.baseUrl}/globe.jpg` : 'https://img.crossess.com/images/globe.jpg', // 北师大8、农大26、重庆医科30，单独设置地球纹理
        shading: 'color', // color 只显示颜色，不受光照等因素影响, 否则可以设置光照 light 属性（lambert、realistic）
        postEffect: { // 光柱 后期渲染
          enable: !this.judgeDeviceType(),
          bloom: { // 高光特效
            enable: true,
            bloomintensity: 0.5,
          },
        },
        light: { // 光柱 设置光照参数，后续可以通过光照反射实现发光柱
          main: {
            intensity: 1,
          },
          ambient: {
            intensity: 10,
            quality: 'high',
          },
          ambientCubemap: {
            exposure: 1.0,
            diffuseIntensity: 2,
            specularIntensity: 2,
          },
        },
        viewControl: { // 鼠标等旋转，缩放等视角控制
          projection: 'perspective', // 透视投影 perspective 正交投影 orthographic
          autoRotate: this.$store.state.data.type != 8, // 是否开启视角绕物体等自动旋转查看，自动旋转 北师大不自转
          autoRotateDirection: 'cw', // 物体自转方向 cw 顺时针 ccw 逆时针
          autoRotateSpeed: 10, // 物体自转速度 角度/秒 例如 10 36s一圈
          autoRotateAfterStill: 3, // 鼠标静止操作后，恢复自转的时间
          damping: 0.8, // 鼠标操作后的惯性视角
          rotateSensitivity: 1, // 鼠标旋转灵敏度 0 无法旋转
          zoomSensitivity: 0, // 鼠标缩放灵敏度 0 无法缩放
          // panSensitivity: [0, 0], // 横向、纵向，平移灵敏度
          distance: 150, // 默认视角距离主体的距离，对应globe来说是距离地球表面的距离
          targetCoord: [116.20, 39.56], // 定位目标的经纬度坐标，可以在获取地理位置完成后设置
          animationDurationUpdate: 1500,
        },
        // layers: [{ // 地球表层的配置，可以设置悬浮层，解决bar3D悬空问题（好像只能是网络图片）
        //   show: true,
        //   type: 'overlay',
        //   intensity: 0,
        //   shading: 'color',
        //   distance: 0,
        //   texture: `${process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/api'}/images/globe.jpg`,
        //   // texture: `${ROOT_PATH}/data-gl/asset/earth.jpg`,
        //   // texture: earthImg,
        // }],
      },
      series: [{
        type: 'bar3D', // 三维柱状图
        coordinateSystem: 'globe', // 使用地球 globe 坐标系
        bevelSize: 1, // 柱子倒角尺寸
        // bevelSmoothness: 2, // 柱子倒角的光滑/圆润度
        itemStyle: { // 柱子的样式
          color: '#fff',
          opacity: 1,
        },
        barSize: 4, // 柱子的粗细
        label: { // 柱子的标签配置
          show: false,
        },
        shading: 'realistic', // 光柱 可以通过光照反射实现发光柱，真实渲染，可以反射光，形成光柱
        data: [],
      }],
    };
    this.myChart.setOption(this.optionGlobe);
    const canvasDom = document.getElementsByTagName('canvas')[0];
    // 不同学校的差异
    const schoolId = parseInt(this.$store.state.data.type, 10);
    switch (true) {
      // 北京外国语学校 || 北京建筑大学 || 北京航空航天大学 || 北京科技大学 || 西安外事学院 || 广州医科 || 陕西中医药
      case schoolId === 2 || schoolId === 4 || schoolId === 5 || schoolId === 6 || schoolId === 7 || schoolId === 9 || schoolId === 10:
        canvasDom.style.top = '2rem';
        canvasDom.style.left = '-10rem';
        canvasDom.style.width = '20rem';
        canvasDom.style.height = '20rem';
        break;
        // 北京协和医学院
      case schoolId === 3:
        canvasDom.style.top = '6rem';
        canvasDom.style.left = '-3rem';
        canvasDom.style.width = '10rem';
        canvasDom.style.height = '10rem';
        break;
        // 北京师范大学、重庆大学 无动画
      case schoolId === 8 || schoolId === 15:
        canvasDom.style.top = '0';
        canvasDom.style.left = '0';
        canvasDom.style.width = '10rem';
        canvasDom.style.height = '10rem';
        break;
      // 北师大实验中学/二龙路中学
      case schoolId === 13:
        canvasDom.style.top = '-5rem';
        canvasDom.style.left = '-2.5rem';
        canvasDom.style.width = '10rem';
        canvasDom.style.height = '10rem';
        break;
        // 西安电子科技大学
      default:
        canvasDom.style.top = '5rem';
        canvasDom.style.left = '-10rem';
        canvasDom.style.width = '20rem';
        canvasDom.style.height = '20rem';
        break;
    }
  },
  methods: {
    // 北师大增加返回按钮
    backTap() {
      window.location.reload();
    },
    // 底部事件
    handleTap(item) {
      switch (item) {
        case 1:
          window.location.href = 'https://yjy.q-alumni.com/yzf/2/';
          break;
        case 2:
          wx.miniProgram.getEnv((env) => {
            console.log('getEnv', env.miniprogram);
            if (env.miniprogram) {
              wx.miniProgram.reLaunch({ url: '/pkgMain/pages/index?page=2' });
            } else {
              weapp({ path: 'pkgMain/pages/index', query: 'page=2' }).then((res) => {
                console.log('跳转小程序 邀你回家', res.data.data);
                window.location.href = res.data.data;
              });
            }
          });
          break;
        case 3:
          wx.miniProgram.getEnv((env) => {
            console.log('getEnv', env.miniprogram);
            if (env.miniprogram) {
              wx.miniProgram.reLaunch({ url: '/pkgMain/pages/index?activeId=97&orderNum=12&page=2' });
            } else {
              weapp({ path: 'pkgMain/pages/index', query: 'activeId=97&orderNum=12&page=2' }).then((res) => {
                console.log('跳转小程序 为母校助力', res.data.data);
                window.location.href = res.data.data;
              });
            }
          });
          break;
        default:
      }
    },

    // 微信开放标签报错
    wxOpenError(error) {
      console.log('微信开放标签报错', error);
    },
    // 判断机型，android无法使用postEffect后期渲染光柱
    judgeDeviceType() {
      const ua = window.navigator.userAgent.toLocaleLowerCase();
      // const isIOS = /iphone|ipad|ipod/.test(ua);
      console.log(ua);
      const isAndroid = /android/.test(ua);
      return isAndroid;
      // return {
      //   isIOS,
      //   isAndroid,
      // };
    },

    // 点亮地图（操作dom）
    clickLight() {
      switch (this.globeType) {
        case 0:
          console.log('进入地球');
          // 北师大单独设置点亮操作流程 拥有用户体系时更改点亮操作流程
          if ((this.$store.state.data.type == 8 || this.$store.state.data.auth) && this.$store.state.data.total) {
            if (this.$store.state.data.type != 8 && this.$store.state.data.auth) {
              this.enterHome();
            }
            this.total = this.$store.state.data.total;
            this.globeType = 3;
            // 点亮全部
            this.allGeolocation();
          } else if (this.$store.state.id == 26) {
            this.globeType = 1;
            this.enterHome();
            this.globeType = 2;
            this.lightGlobe();
          } else {
            this.globeType = 1;
            this.enterHome();
          }
          break;
        case 1:
          console.log('点亮地球');
          // 北师大、重庆医科单独设置点亮操作流程
          if (this.$store.state.data.type == 8 || this.$store.state.data.type == 30) {
            this.globeType = 3;
            this.lightGlobe();
          } else {
            this.globeType = 2;
            this.lightGlobe();
          }
          break;
        case 2:
          console.log('获取地球全部点亮');
          this.globeType = 3;
          this.allGeolocation();
          break;
        case 3:
          console.log('进入详情');
          // 重庆大学点击返回上一页
          if (this.$store.state.data.type == 15) {
            window.history.back(1);
          } else {
            this.enterDetail();
          }

          break;
        default:
          break;
      }
    },

    // 进入地球
    enterHome() {
      // 重置地球旋转角度
      const option = this.myChart.getOption(this.optionGlobe);
      // eslint-disable-next-line max-len
      const beta = option.globe[0].viewControl.beta - 360 * parseInt(option.globe[0].viewControl.beta / 360, 10);
      option.globe[0].viewControl.beta = beta;
      this.myChart.setOption(this.optionGlobe, { notMerge: true, lazyUpdate: false });

      // 进入地球动画
      const canvasDom = document.getElementsByTagName('canvas')[0];
      canvasDom.style.transition = 'all 2s ease';
      canvasDom.style.top = '0';
      canvasDom.style.left = '0';
      canvasDom.style.width = '10rem';
      canvasDom.style.height = '10rem';
      // 进入后停止自转
      setTimeout(() => {
        this.optionGlobe.globe.viewControl.autoRotate = false;
        this.myChart.setOption(this.optionGlobe, { notMerge: false, lazyUpdate: true });
      }, 2000);
    },

    // 点亮地球
    lightGlobe() {
      // 获取地理位置
      this.getLocation();
      // 无法获取经纬度的测试
      if (process.env.NODE_ENV !== 'production') {
        const lat = 39.56; // 纬度
        const lag = 116.20; // 经度
        console.log(`纬度:${lat},经度:${lag}`);
        this.position = { lat, lag };
        // 上传经纬度
        this.uploadGeolocation();
        // 更新地球数据
        this.optionGlobe.series[0].data = [this.position.lag, this.position.lat, 1];
        this.optionGlobe.globe.viewControl.targetCoord = [this.position.lag, this.position.lat];
        // 北师大单独设置点亮操作流程
        if (this.$store.state.data.type == 8) {
          this.allGeolocation();
        } else {
          this.optionGlobe.series[0].data = [{
            value: [this.position.lag, this.position.lat, 1],
            itemStyle: {
              color: 'red',
              opacity: 1,
            },
          }];
          this.myChart.setOption(this.optionGlobe, { notMerge: false, lazyUpdate: true });
        }
        // 农大、重庆医科单独设置点亮操作流程
        if (this.$store.state.id == 26 || this.$store.state.data.type == 30) {
          setTimeout(() => {
            this.globeType = 3;
            this.allGeolocation();
          }, 1000);
        }
      }
    },

    // 获取经纬度
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
      } else {
        // eslint-disable-next-line no-alert
        alert('浏览器不支持地理定位。');
      }
    },

    // 定位成功回调
    showPosition(position) {
      const lat = position.coords.latitude; // 纬度
      const lag = position.coords.longitude; // 经度
      console.log(`纬度:${lat},经度:${lag}`);
      this.position = { lat, lag };
      // 上传经纬度
      this.uploadGeolocation();
      // 更新地球数据
      this.optionGlobe.series[0].data = [this.position.lag, this.position.lat, 1];
      this.optionGlobe.globe.viewControl.targetCoord = [this.position.lag, this.position.lat];
      // 北师大单独设置点亮操作流程
      if (this.$store.state.data.type == 8) {
        this.optionGlobe.series[0].data = [{
          value: [this.position.lag, this.position.lat, 1],
          itemStyle: {
            color: '#fff',
            opacity: 1,
          },
        }];
        this.myChart.setOption(this.optionGlobe, { notMerge: false, lazyUpdate: true });
        this.allGeolocation();
      } else {
        this.optionGlobe.series[0].data = [{
          value: [this.position.lag, this.position.lat, 1],
          itemStyle: {
            color: 'red',
            opacity: 1,
          },
        }];
        this.myChart.setOption(this.optionGlobe, { notMerge: false, lazyUpdate: true });
      }

      if (this.$store.state.id == 26 || this.$store.state.data.type == 30) {
        setTimeout(() => {
          this.globeType = 3;
          this.allGeolocation();
        }, 1000);
      }
    },

    // 定位失败提示
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          alert('定位失败,用户拒绝请求地理定位');
          break;
        case error.POSITION_UNAVAILABLE:
          alert('定位失败,位置信息是不可用');
          break;
        case error.TIMEOUT:
          alert('定位失败,请求获取用户位置超时');
          break;
        case error.UNKNOWN_ERROR:
          alert('定位失败,定位系统失效');
          break;
        default:
          break;
      }
    },

    // 上传经纬度
    async uploadGeolocation() {
      if (!this.position.lag) {
        return;
      }
      const { unionid, openid, nickname } = this.$route.query;
      const { data: { data } } = await geolocation({
        lng: this.position.lag,
        lat: this.position.lat,
        unionid,
        openid,
        nickname,
      });
      this.total = data ? data.total : 0;
      this.area = data ? data.area : '';
      console.log('请求成功', data);
      // 北师大单独设置重新请求分享信息
      if (this.$store.state.data.auth || this.$store.state.data.type == 8) {
        // 重新请求分享信息
        this.setShareData();
      }
      // 中国农业大学设置分享标题
      if (this.$store.state.id == 26) {
        this.ndSetShareData();
      }
    },

    // 查看全部
    allGeolocation() {
      // 获取全部经纬度
      this.globeGeo();
    },

    // 请求地球数据
    async globeGeo() {
      const { data: { data = {} } } = await globe();
      console.log('请求成功', data);
      if (this.position.lag) {
        this.optionGlobe.series[0].data = [this.position.lag, this.position.lat, 1];
        this.optionGlobe.globe.viewControl.targetCoord = [this.position.lag, this.position.lat];
        data.push({
          value: [this.position.lag, this.position.lat, 1],
        });
        // 加入 自己的红色光点
        // data.push({
        //   value: [this.position.lag, this.position.lat, 1],
        //   itemStyle: {
        //     color: 'red',
        //     opacity: 1,
        //   },
        // });
      }
      /* eslint-disable */
      // 可以正确显示柱体高度的数据 [[-83,76.5,1.1],[-85.5,73.5,2.9],[-78,73,1.5],[-56,72.5,14.9],[-157.5,71.5,1.9]]
      /* eslint-disable */
      this.optionGlobe.series[0].data = data;
      this.myChart.setOption(this.optionGlobe, { notMerge: false, lazyUpdate: true });
    },

    // 进入详情
    enterDetail() {
      this.$emit('detail');
    },

    // 重新设置分享
    setShareData() {
      // 获取学校资源
      school().then(({ data: { data = {} } }) => {
        console.log('获取学校资源', data, window.location.href);
        if (data.auth) {
          console.log('当前用户身份信息', this.$store.state.data.openid);
          data.openid = this.$store.state.data.openid;
          data.nickname = this.$store.state.data.nickname;
        }
        if (!data.type) {
          data.type = data.id;
        }
        data.id = parseInt(data.id);
        this.$store.commit('setData', data);
        document.title = this.$store.state.id == 8 ? '寻找北师大的你' : this.$store.state.data.title;
        wx.updateAppMessageShareData({
          title: this.$store.state.data.total ? this.$store.state.data.userTitle : this.$store.state.data.title,
          desc: this.$store.state.data.desc,
          link: window.location.href.split('?')[0],
          imgUrl: `${this.$store.state.data.baseUrl}/logo.png`,
          success(res) {
            console.log('分享设置成功', res);
          },
          fail(res) {
            console.log('分享设置失败', res);
          },
        });
        wx.updateTimelineShareData({
          title: this.$store.state.data.total ? this.$store.state.data.userTitle : this.$store.state.data.title,
          link: window.location.href.split('?')[0],
          imgUrl: `${this.$store.state.data.baseUrl}/logo.png`,
          success(res) {
            console.log('朋友圈分享设置成功', res);
          },
          fail(res) {
            console.log('朋友圈分享设置失败', res);
          },
        });

        wx.miniProgram.getEnv((env) => {
          console.log('getEnv', env.miniprogram);
          if (env.miniprogram) {
            wx.miniProgram.postMessage({
              data: {
                title: this.$store.state.data.total ? this.$store.state.data.userTitle : this.$store.state.data.title,
                path: `/pages/web?url=${encodeURIComponent(window.location.href)}`,
                imageUrl: `${this.$store.state.data.baseUrl}/mini_program_share_url.png`,
              },
            });
          } else {
            console.log('不在小程序内');
          }
        });
      });
    },

    ndSetShareData() {
      wx.updateAppMessageShareData({
        title: this.total ? `我为中国农业大学建校120周年送出了第${this.total}份生日祝福` : this.$store.state.data.title,
        desc: this.$store.state.data.desc,
        link: window.location.href.split('?')[0],
        imgUrl: `${this.$store.state.data.baseUrl}/logo.png`,
        success(res) {
          console.log('分享设置成功', res);
        },
        fail(res) {
          console.log('分享设置失败', res);
        },
      });
      wx.updateTimelineShareData({
        title: this.total ? `我为中国农业大学建校120周年送出了第${this.total}份生日祝福` : this.$store.state.data.title,
        link: window.location.href.split('?')[0],
        imgUrl: `${this.$store.state.data.baseUrl}/logo.png`,
        success(res) {
          console.log('朋友圈分享设置成功', res);
        },
        fail(res) {
          console.log('朋友圈分享设置失败', res);
        },
      })
    },

    // 29 广东培正跳转到首页校友的同城板块
    peizhengStudentTap() {
      // 2. 调用 wx.miniProgram.reLaunch 跳转
      console.log('jssdk', wx);
      if (typeof wx !== 'undefined' && wx.miniProgram && window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.reLaunch({
          url: '/pkgMain/pages/index?index=0&studentsActiveId=2', // 跳转到小程序首页
          success: function(res) {
              console.log('跳转成功', res);
          },
          fail: function(err) {
              console.error('跳转失败', err);
              // 跳转失败时的业务逻辑，比如提示用户
          },
          complete: function() {
              console.log('跳转API调用完成');
          }
        });
      } else {
        window.location.href = 'weixin://dl/business/?appid=wxa260e438df35dc68&path=pkgMain/pages/index&query=index%3D0%26studentsActiveId%3D2';
      }
    }
  },
  watch: {
    // width() {
    //   console.log(this.width);
    // },
  },
};
</script>

<style lang="less" scoped>
.globe-main {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .back-img {
    position: fixed;
    width: 50px;
    height: 50px;
    left: 20px;
    top: 20px;
  }
  .bg-img {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  .bg-img-30 {
    background-position: center !important;
    background-size: 100% 100% !important;
  }
  .bg1-img-30 {
    z-index: 1;
  }
  .bg4-img {
    z-index: 1;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 579px;
    height: 550px;
  }
  .bg5-img {
    z-index: 1;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    object-fit: fill;
  }
  .click-num {
    position: absolute;
    z-index: 1;
    top: 180px;
    display: flex;
    align-items: flex-end;
    font-size: 33px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    text-shadow: 1px 1px 5px #fff;
    p {
      margin-left: 10px;
      margin-right: 10px;
      font-size: 48px;
    }
    &.click-num-30 {
      top: 206px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #4E0605;
      text-align: center;
      font-style: normal;
      text-transform: none;
      div {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      p {
        font-size: 36px;
        color: #BB1F23;
      }
    }
  }
  .echarts-26 {
    top: 390px;
  }
  .click-num-nd {
    width: 641px;
    height: 320px;
    top: 52px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    line-height: 46px;
    color: #C20102;
    text-shadow: 4px 0px 0px #FFD26F;
    text-align: center;
    font-style: normal;
    text-transform: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    div {
      display: flex;
      align-items: flex-end;
    }
    p {
      margin-bottom: 5px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 36px;
      line-height: 46px;
      color: #BA1C22;
      text-align: center;
      font-style: normal;
      text-transform: none;
      background: radial-gradient(0deg, #941A11 0%, #9D1C14 0%, #E8CF83 67%);
    }
  }
  .beishida-click-num {
    top: 120px;
    height: 30px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #2B2B2B;
    line-height: 33px;
    text-shadow: none;
    p {
      color: #BE261F;
      margin-left: 10px;
      margin-right: 10px;
      font-size: 36px;
    }
  }
  #echarts {
    position: absolute;
    transition: all 2s ease;
    width: 10rem;
    height: 10rem;
    // left: -10rem;
    // bottom: -10rem;
  }
  .logo-tag {
    position: absolute;
    top: 35px;
    right: 25px;
    width: 198px;
    z-index: 10;
  }
  .title {
    position: absolute;
    top: 190px;
    width: 200px;
    // height: 614px;
    z-index: 10;
  }
  .title-19 {
    position: absolute;
    top: 224px;
    width: 267px;
    // height: 614px;
    z-index: 10;
  }
  .click-button {
    position: absolute;
    z-index: 11;
    border: none;
    background-size: cover;
    bottom: 100px;
    width: 404px;
    height: 104px;
  }
  .click-button-30 {
    bottom: 88px;
    width: 100%;
    height: 106px;
    background-size: auto 100%;  /* 宽度自适应，高度撑满容器 */
    background-repeat: no-repeat;
    background-position: center; /* 居中显示，防止偏移 */
  }
  .click-button-19 {
    position: absolute;
    z-index: 11;
    border: none;
    background-size: cover;
    bottom: 100px;
    width: 670px;
    height: 94px;
  }
  .click-button-21 {
    position: absolute;
    z-index: 11;
    border: none;
    background-size: cover;
    bottom: 100px;
    width: 534px;
    height: 118px;
  }
  .click-button-26 {
    position: absolute;
    z-index: 11;
    border: none;
    background-size: cover;
    bottom: 140px;
    width: 472px;
    height: 147px;
  }
  .detail {
    position: absolute;
    top: 60px;
    font-size: 20px;
  }
  .click-button-29 {
    bottom: 224px !important;
  }
  .click-button-student {
    position: absolute;
    z-index: 11;
    border: none;
    background-size: cover;
    bottom: 100px;
    width: 404px;
    height: 104px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .code {
    width: 580px;
    height: 100px;
    position: absolute;
    right: 50px;
    bottom: 20px;
  }
  .bottom-handle {
    position: absolute;
    bottom: 0;
    width: 100vw;
    display: flex;
    .handle {
      position: relative;
      flex: 1;
      text-align: center;
      img {
        width: 129px;
        height: 129px;
      }
      div {
        text-align: center;
        margin: 19px 0 50px 0;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #DB9256;
      }
    }
  }
}

</style>
